// extracted by mini-css-extract-plugin
export default {"header_column":"report-errors-view_header_column__9d679","cta_text":"report-errors-view_cta_text__JKiqF","full_sync_message":"report-errors-view_full_sync_message__YJHat"};